export enum SliAnalytics {
	GetTeamProfile = 'GetTeamProfile',
	GetTeamMembers = 'GetTeamMembers',
	GetTeamLinks = 'GetTeamLinks',
	TeamSearch = 'TeamSearch',
	AccountCentricUserSearch = 'AccountCentricUserSearch',
	LoadProfileAbout = 'LoadProfileAbout',
	GetSettings = 'GetSettings',
}
